import CampaignsPageEdit from 'views/pages/Campaigns/CampaignsPageEdit';
import ThomasCampaignPage from 'views/pages/ThomasCampaigns/ThomasCampaignPage';
import ThomasAdvertiserPage from 'views/pages/ThomasAdvertisers/ThomasAdvertiserPage';
import InventoryPage from 'views/pages/Campaigns/InventoryPage';
import ThomasAdvertiserListPage from 'views/pages/ThomasAdvertisers/ThomasAdvertiserListPage';
import ThomasAdvertiserAddPage from 'views/pages/ThomasAdvertisers/ThomasAdvertiserAddPage';
import AddServerPage from 'views/pages/AdServers/AdServerPage';
import DisplayAdPlatformPage from 'views/pages/DisplayAdPlatforms/DisplayAdPlatformPage';
import CampaignProductPage from 'views/pages/CampaignProducts/CampaignProductPage';
import ErrorPage from 'views/components/Access/ErrorPage';
import AccessPage from 'views/components/Access/AccessPage';
import ProductFulfillmentListPage from 'views/pages/ProductFulfillments/ProductFulfillmentListPage';
import P3ConfigurationsPage from 'views/pages/P3Configurations/P3ConfigurationsPage';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import AdvertisersByProductListPage from 'views/pages/AdvertisersByProduct/AdvertisersByProductListPage';
import ProductFulfillmentListAuditPage from 'views/pages/ProductFulfillments/ProductFulfillmentListAuditPage';

export const routes = [
  {
    path: '/home',
    name: 'Accounts',
    component: ThomasAdvertiserListPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/inventory/pvs',
    name: ' PVS Inventory',
    component: InventoryPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/advertisers',
    name: 'Accounts',
    component: ThomasAdvertiserListPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/advertisers/add',
    name: 'Add Companies',
    component: ThomasAdvertiserAddPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/advertisers/pvs',
    name: 'PVS Accounts',
    component: AdvertisersByProductListPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/advertisers/points',
    name: 'Points Accounts',
    component: AdvertisersByProductListPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/adservers',
    name: 'Adservers',
    component: AddServerPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/displayadplatforms',
    name: 'Display Ad Platforms',
    component: DisplayAdPlatformPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/campaignproducts',
    name: 'Campaign Products',
    component: CampaignProductPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/access',
    name: 'Access',
    component: AccessPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/templates',
    name: 'Configurations',
    component: P3ConfigurationsPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
  },
  {
    path: '/fulfillments/audit',
    name: 'Next Publish Campaigns',
    component: ProductFulfillmentListAuditPage,
    navShow: false,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/fulfillments',
    name: 'Pending Campaigns',
    component: ProductFulfillmentListPage,
    navShow: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/advertisers/:tgramsId',
    name: 'Thomas Companies',
    component: ThomasAdvertiserPage,
    navShow: true,
    exact: 'exact',
    checkAccess: CONSTANTS.ACCESS_CONTROL.MODIFIED_ACCESS
  },
  {
    path: '/advertisers/:tgramsId/campaigns/create',
    name: 'Edit Campaign',
    component: CampaignsPageEdit,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: '/advertisers/:tgramsId/p3campaigns/create',
    name: 'Create Campaign',
    component: CampaignsPageEdit,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
  },
  {
    path: `/advertisers/:tgramsId/campaigns/:campaignId/edit`,
    name: 'Companies Page Edit',
    component: CampaignsPageEdit,
    navShow: true,
    exact: 'exact',
    checkAccess: CONSTANTS.ACCESS_CONTROL.MODIFIED_ACCESS
  },
  {
    path: `/advertisers/:tgramsId/campaigns/:campaignId`,
    name: '',
    component: ThomasCampaignPage,
    navShow: true,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.MODIFIED_ACCESS
  },
  {
    path: `/advertisers/:tgramsId/products/:productId`,
    name: '',
    component: ThomasAdvertiserPage,
    navShow: false,
    exact: true,
    checkAccess: CONSTANTS.ACCESS_CONTROL.MODIFIED_ACCESS
  }
];
